import { UserFieldErrorMessages } from "@constants/Errors";
import {
  handleNumericalFieldChange,
  phoneNumberChange,
} from "@services/ErrorHandling";
import { TextInputField } from "@components/Inputs/TextInputField/TextInputField";
import { USER } from "@types/user";

type UserAccountInfoCardProps = {
  userData: USER;
  errors: any;
  updateUserData: (field: string, value: any) => void;
  updateError: (field: string, value: any) => void;
  adminRoleSelected: boolean;
  contactRoleSelected: boolean;
  hasYobelyLicense: boolean;
  createUser: boolean;
};

export const UserAccountInfoCard = ({
  userData,
  errors,
  updateUserData,
  updateError,
  adminRoleSelected,
  hasYobelyLicense,
  contactRoleSelected,
  createUser,
}: UserAccountInfoCardProps) => {
  return (
    <div>
      <TextInputField
        label="社員番号"
        value={userData?.employee_number}
        placeholder="123456"
        onChange={(e) =>
          handleNumericalFieldChange(
            "employee_number",
            e.target.value,
            updateUserData,
            updateError,
          )
        }
      />
      {errors.employee_number && (
        <p className="text-red-500">
          {UserFieldErrorMessages.employeeNumberError}
        </p>
      )}
      <div className="mt-5 divider"></div>
      <TextInputField
        label="メールアドレス 1"
        value={userData?.email}
        placeholder="example@example.com"
        onChange={(e) => updateUserData("email", e.target.value)}
        required={adminRoleSelected}
      />
      {errors.email_exists && (
        <p className="text-red-500">
          {UserFieldErrorMessages.emailExistsError}
        </p>
      )}

      <div className="mt-5 divider" />

      <TextInputField
        label="メールアドレス 2"
        value={userData?.secondary_email}
        placeholder="example@example.com"
        onChange={(e) => updateUserData("secondary_email", e.target.value)}
      />
      {errors.email_exists && (
        <p className="text-red-500">
          {UserFieldErrorMessages.emailExistsError}
        </p>
      )}

      <div className="mt-5 divider" />

      <TextInputField
        label="電話番号 1"
        value={userData?.personal_tel}
        required={!contactRoleSelected && !hasYobelyLicense}
        placeholder="（例）08012345678"
        onChange={(e) => {
          phoneNumberChange(
            "personal_tel",
            e.target.value,
            updateUserData,
            updateError,
            createUser ? 1 : userData?.user_type,
          );
        }}
      />

      {errors.personal_tel && (
        <p className="text-red-500">
          {createUser || userData?.user_type == 2
            ? UserFieldErrorMessages.telephoneNumberError
            : UserFieldErrorMessages.telephoneNumberErrorNoLimit}
        </p>
      )}
      <div className="mt-5 divider"></div>

      <TextInputField
        label="電話番号 2"
        value={userData?.secondary_phone_number}
        placeholder="（例）08012345678"
        onChange={(e) => {
          phoneNumberChange(
            "secondary_phone_number",
            e.target.value,
            updateUserData,
            updateError,
            createUser ? 1 : userData?.user_type,
          );
        }}
      />

      {errors.secondary_phone_number && (
        <p className="text-red-500">
          {createUser || userData?.user_type == 2
            ? UserFieldErrorMessages.telephoneNumberError
            : UserFieldErrorMessages.telephoneNumberErrorNoLimit}
        </p>
      )}
      <div className="mt-5 divider"></div>
    </div>
  );
};
